<template>
    <div class="questionnaire-container button-container row visible-on">
        <button ref="button" :class="[type === 'light' ? 'button-light main-color-style main-border-style custom-border-color custom-color' : 'button-normal main-background-style custom-bg-color', width === 'large' ? 'button-large' : '', isDisabled === 'true' ? 'button-disabled' : '']">{{ text }}</button>
    </div>
</template>
<script>

// @text: the button text.
// @type: control the button is light or normal style.
// @width: control the size of button. large or normal.
// @isDisabled: disable to button or not.

export default {
  props: ['text', 'type', 'width', 'isDisabled'],
  data () {
    return {

    }
  },
  watch: {
    isDisabled (val) {
      if (val === 'true' || val === true) {
        this.$set(this.$refs.button, 'disabled', 'disabled')
      } else {
        this.$set(this.$refs.button, 'disabled', false)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
.button-container {
    .button {
        padding: 0 20px;
        width: 100%;
        height: 4rem;
        user-select: none;
    }
    .button-large {
        width: 150%;
    }
    .button-normal {
        @extend .button;
        color: white;
        border: none;
    }
    .button-light {
        @extend .button;
        background-color: white;
    }
    .button-disabled {
        background-color: gray;
    }
}

/* 小型设备（平板电脑，768px 起） */
@media (min-width: 768px) {
    .button {
        height: 40px !important;
    }
    .button-large {
        width: 200% !important;
    }
}

</style>
